/* Movatic WMS — Frontend | CesarFilho 932048016
   nav/menu-utils.ts — helpers puros do menu (extraidos do SidebarNav, P3a).
   shouldShow (roles) + flattenLeafs (folhas navegaveis). Sem React/stores. */
import type { MenuItem } from '@/nav/menu'

export function shouldShow(item: MenuItem, user: any): boolean {
  // ADR-0042: fail-closed ANTES do early-return dos roles -- itens superuserOnly
  // (ex.: MOVATIC DEV) escondem-se de quem nao e' superusuario.
  if (item.superuserOnly && !user?.is_superuser) return false
  const roles = item.roles
  if (!roles || roles.length === 0) return true
  const role = String(user?.role || user?.groups?.[0] || '')
  return roles.includes(role)
}

export function flattenLeafs(items: MenuItem[], user: any): MenuItem[] {
  const output: MenuItem[] = []
  function walk(list: MenuItem[]) {
    for (const item of list) {
      if (!shouldShow(item, user)) continue
      const hasChildren = !!item.children?.length
      if (!hasChildren && (item.path || item.href)) {
        output.push(item)
      }
      if (hasChildren) {
        walk(item.children || [])
      }
    }
  }
  walk(items)
  return output
}
